import styled from 'styled-components';

import { Observer } from '@xing-com/crate-communication-in-view';
import { TopBar as TobBarComponent } from '@xing-com/crate-layout-top-bar';
import { GridContainer, GridItem } from '@xing-com/grid';
import { mediaWideNavless } from '@xing-com/layout-tokens';
import { space3XL, space6XL, spaceXXL } from '@xing-com/tokens';

export const StyledObserver = styled(Observer)`
  width: 100%;
`;

export const Container = styled.div`
  max-width: 944px;
  margin: 0 auto;
`;

export const TopBar = styled(TobBarComponent)`
  @media print {
    display: none;
  }
`;

export const JobDetailsGridContainer = styled(GridContainer).attrs({
  variant: 'FullSize',
})`
  row-gap: ${space3XL};
  padding: 0;
  margin-bottom: ${space6XL};

  @media print {
    margin-bottom: 0;
  }
`;

export const SimilarJobsSidebarGridItem = styled(GridItem).attrs({
  spanLarge: 4,
})`
  display: none;
  margin-left: ${spaceXXL};

  @media ${mediaWideNavless} {
    display: block;
  }
`;
